import { Add as AddIcon } from "@mui/icons-material";
import { Box, Button } from "@mui/material";
import { useContext } from "react";
import { useTranslation } from "react-i18next";
import { RoundedButton } from "../../../../common/components/styled/styled";
import { ShiftOrderContext } from "./OrderShortDataProvider";
import { hasManuallyOfferedRows } from "./orderFormShortRowHandlers";

const OrderFormShortButtons = () => {
  const { t } = useTranslation(["common, order"]);

  const { bundling, handleAddRow, handleAddBundleContainer, orderRows } =
    useContext(ShiftOrderContext);

  return (
    <>
      {!bundling.show && (
        <Box
          sx={{
            marginTop: "0.5rem",
            marginLeft: hasManuallyOfferedRows(orderRows) ? "36px" : "12px",
          }}
        >
          <Button
            onClick={handleAddRow}
            startIcon={<AddIcon />}
            variant="outlined"
            sx={{ borderRadius: "20px", marginRight: "0.5rem" }}
          >
            {t("common:shift")}
          </Button>
          <RoundedButton
            startIcon={<AddIcon />}
            variant="outlined"
            onClick={handleAddBundleContainer}
          >
            {t("order:shiftBundle")}
          </RoundedButton>
        </Box>
      )}
    </>
  );
};

export default OrderFormShortButtons;
